export default __webpack_public_path__ + "static/media/480_store04-nl-web.3857f19e.png";